"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarMonthPicker = void 0;
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
const react_1 = __importDefault(require("react"));
const lab_1 = require("@mui/lab");
const WithBaseCalendarDatePicker_1 = require("../WithBaseCalendarDatePicker");
/**
 * Month wise date picker
 */
exports.CalendarMonthPicker = WithBaseCalendarDatePicker_1.withBaseCalendarDatePicker((props) => (react_1.default.createElement(lab_1.DatePicker, Object.assign({}, props, { views: ['year', 'month'], openTo: "month", inputFormat: "MMMM yyyy" }))));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FsZW5kYXJNb250aFBpY2tlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jYWxlbmRhci9kYXRlLXBpY2tlci9waWNrZXJzL0NhbGVuZGFyTW9udGhQaWNrZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBOzs7Ozs7R0FNRztBQUNILGtEQUEwQjtBQUMxQixrQ0FBdUQ7QUFFdkQsOEVBQTJFO0FBRTNFOztHQUVHO0FBQ1UsUUFBQSxtQkFBbUIsR0FBRyx1REFBMEIsQ0FBQyxDQUFDLEtBQXNCLEVBQUUsRUFBRSxDQUFDLENBQ3hGLDhCQUFDLGdCQUFVLG9CQUFLLEtBQUssSUFBRSxLQUFLLEVBQUUsQ0FBQyxNQUFNLEVBQUUsT0FBTyxDQUFDLEVBQUUsTUFBTSxFQUFDLE9BQU8sRUFBQyxXQUFXLEVBQUMsV0FBVyxJQUFHLENBQzNGLENBQUMsQ0FBQyJ9